import * as React from 'react';
import './GroupPersonnelEditPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { RestrictedLayout } from "../../../components/layouts/index";
import { IPersonnelRoleReduxFormState, initialPersonnelRoleState } from "../../../reducers/reactReduxForms/personnelRole";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, DatePickerFormInputFabric, GenericFormGroup, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as PersonnelRoleActions from '../../../actions/personnelRole';
import * as GroupActions from '../../../actions/groups';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import { GroupSubMenu } from '../../../helpers/subMenuHelper';
import * as FormHelper from '../../../helpers/formHelper';
interface IGroupPersonnelEditPageParams {
  groupId: number;
  personnelRoleId: number;
}
interface IGroupPersonnelEditPageProps {
  form: Dtos.PersonnelRole & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: IPersonnelRoleReduxFormState;
  location: Location;
  groupId: number;
  personnelRoleId: number;
  match: match<IGroupPersonnelEditPageParams>;
  history: History;

  // From state
  personnelRole: Dtos.PersonnelRole;
  group: Dtos.Group;
  lookups: Dtos.Lookup[];
  loadingGroup: boolean;
  loadingPersonnelRole: boolean;
  loadPersonnelRoleSuccess: boolean;
  loadPersonnelRoleFailure: boolean;
  savingPersonnelRole: boolean;
  savePersonnelRoleSuccess: boolean;
  savePersonnelRoleFailure: boolean;
  creatingPersonnelRole: boolean;
  createPersonnelRoleSuccess: boolean;
  createPersonnelRoleFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface IGroupPersonnelEditPageActions {
  clearPersonnelRole: PersonnelRoleActions.IPersonnelRoleClearActionCreator;
  loadPersonnelRole: PersonnelRoleActions.IPersonnelRoleLoadByIdActionCreator;
  savePersonnelRole: PersonnelRoleActions.IPersonnelRoleSaveActionCreator;
  createPersonnelRole: PersonnelRoleActions.IPersonnelRoleCreateActionCreator;
  clearGroup: GroupActions.IGroupClearActionCreator;
  loadGroup: GroupActions.IGroupLoadByIdActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type GroupPersonnelEditPageProps = IGroupPersonnelEditPageProps & IGroupPersonnelEditPageActions;
const formName: string = "personnelRole";
const reduxFormName: string = "reduxForms.personnelRole";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class GroupPersonnelEditPage extends React.PureComponent<GroupPersonnelEditPageProps, any> {
  constructor(props: GroupPersonnelEditPageProps) {
    super(props);
    this.clearPersonnelRole = this.clearPersonnelRole.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadPersonnelRole,
      createPersonnelRole,
      navigate,
      navigateReplace,
      personnelRoleId,
      groupId,
      loadGroup
    } = this.props;
    if (personnelRoleId) {
      loadPersonnelRole(personnelRoleId);
    } else if (!personnelRoleId) {
      createPersonnelRole(null, null, null, groupId, null);
    }
    loadGroup(groupId);
  }
  componentWillReceiveProps(nextProps: GroupPersonnelEditPageProps) {}
  componentDidUpdate(prevProps: GroupPersonnelEditPageProps, prevState) {
    const {
      form,
      groupId,
      personnelRoleId,
      personnelRole,
      navigateReplace,
      loadPersonnelRole,
      loadGroup,
      loadingPersonnelRole,
      loadPersonnelRoleSuccess,
      savingPersonnelRole,
      savePersonnelRoleSuccess,
      savePersonnelRoleFailure,
      createPersonnelRole,
      validationFailures,
      creatingPersonnelRole,
      createPersonnelRoleSuccess,
      navigate
    } = this.props;
    if (groupId && prevProps.groupId != groupId) {
      loadGroup(groupId);
    }
    if (personnelRoleId && prevProps.personnelRoleId != personnelRoleId) {
      loadPersonnelRole(personnelRoleId);
    } else if (!personnelRoleId && prevProps.personnelRoleId) {
      createPersonnelRole(null, null, null, groupId, null);
    }
    if (!loadingPersonnelRole && prevProps.loadingPersonnelRole) {
      if (loadPersonnelRoleSuccess) {
        this.loadForm();
      } else {}
    }
    if (!savingPersonnelRole && prevProps.savingPersonnelRole) {
      if (savePersonnelRoleSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);

          // toggleMessageModal();
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/groups/" + groupId + "/personnel");
        } else if (!form.saveAndReturn && personnelRoleId && personnelRoleId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !personnelRoleId && personnelRole && personnelRole.id > 0) {
          navigate("/groups/" + groupId + "/personnel/" + personnelRole.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingPersonnelRole && prevProps.creatingPersonnelRole) {
      if (createPersonnelRoleSuccess) {
        this.loadForm();
      } else {}
    }
  }
  componentWillUpdate(nextProps: GroupPersonnelEditPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearPersonnelRole();
    loadForm(reduxFormName, initialPersonnelRoleState);
    resetForm(reduxFormName);
  }
  clearPersonnelRole() {
    this.props.clearPersonnelRole();
    this.props.clearGroup();
  }
  render() {
    const {
      loadingGroup,
      loadingPersonnelRole,
      creatingPersonnelRole,
      group,
      permissions
    } = this.props;
    let id = group ? group.id : 0;
    return <RestrictedLayout permission={Dtos.Permission.GroupPersonnelRoleView} subMenuItems={GroupSubMenu(id, permissions)} loading={loadingGroup || loadingPersonnelRole || creatingPersonnelRole} data-sentry-element="RestrictedLayout" data-sentry-component="GroupPersonnelEditPage" data-sentry-source-file="GroupPersonnelEditPage.tsx">
            {this.renderContent()}
        </RestrictedLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingPersonnelRole,
      permissions
    } = this.props;
    let noPermissionToEditMessage = false;
    if (form.id && form.id > 0 && validationFailures && validationFailures.filter(f => f.errorCode == "PR-005").length > 0) {
      noPermissionToEditMessage = true;
    }
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.GroupPersonnelRoleUpdate, Dtos.Permission.GroupPersonnelRoleCreate);
    const formDisabled: boolean = !hasPermission || savingPersonnelRole || formState && formState.formStatus == Dtos.FormStatus.Disabled || noPermissionToEditMessage;
    const formDisabledOnEdit: boolean = !hasPermission || FormHelper.isEdit(formState, form);
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      parent: {
        type: RegistrationComponent.RegistrationElement,
        component: <div>
                    {renderFormControls(form, "PersonnelRole", {
            trialDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.trialDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            },
            institutionDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.institutionDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            },
            groupDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.groupDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            }
          }, lookups, validationFailures, formProperties, changeForm)}
                </div>
      },
      personnelId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabledOnEdit,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "PersonnelId", lookups), form.personnelId)
        }
      },
      roleId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabledOnEdit,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "RoleId", lookups), form.roleId)
        }
      },
      dateStarted: {
        type: RegistrationComponent.RegistrationControl,
        inputType: DatePickerFormInputFabric,
        validationMessageAbove: true,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " ",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          if (value) {
            changeForm(reduxFormName + parentModel + '.dateCeased', null);
          }
        }
      },
      dateCeased: {
        type: RegistrationComponent.RegistrationControl,
        inputType: DatePickerFormInputFabric,
        validationMessageAbove: true,
        inputDisabled: formDisabled,
        disabledFn: (form: Dtos.PersonnelRole, arrayKey: string) => {
          if (form) {
            if (form.active) {
              return true;
            }
          }
          return false;
        }
      }
    };
    return <div>
            <h3>Personnel Role</h3>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {noPermissionToEditMessage && <div className="alert alert-warning d-flex mt-2 mb-2">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>You cannot edit a role that is higher than your own.</span>
                    </div>}
                {renderFormControls(form, "personnelRole", formComponents, lookups, validationFailures, formProperties, changeForm)}

                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>
        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.PersonnelRole) {
    const {
      savePersonnelRole
    } = this.props;
    if (data) {
      let changes: Dtos.PersonnelRole = ({} as Dtos.PersonnelRole);
      savePersonnelRole(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.Group) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      groupId,
      navigate
    } = this.props;
    navigate("/groups/" + groupId + "/personnel");
  }
  loadForm() {
    const {
      loadForm,
      personnelRole
    } = this.props;
    let extraData: Dtos.PersonnelRole = ({} as Dtos.PersonnelRole);
    loadForm(reduxFormName, Object.assign({
      ...personnelRole
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: GroupPersonnelEditPageProps): IGroupPersonnelEditPageProps => {
  let personnelRole: Dtos.PersonnelRole | undefined = !(state.personnelRole.formData instanceof Array) ? state.personnelRole.formData : undefined;
  let group: Dtos.Group | undefined = !(state.groups.formData instanceof Array) ? state.groups.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    groupId: ownProps.match ? ownProps.match.params.groupId : undefined!,
    personnelRoleId: ownProps.match && ownProps.match.params.personnelRoleId.toString() != "create" ? ownProps.match.params.personnelRoleId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    personnelRole: personnelRole!,
    group: group!,
    loadingPersonnelRole: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Pending,
    loadPersonnelRoleSuccess: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Success,
    loadPersonnelRoleFailure: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Failure,
    savingPersonnelRole: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Pending,
    savePersonnelRoleSuccess: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Success,
    savePersonnelRoleFailure: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Failure,
    creatingPersonnelRole: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Pending,
    createPersonnelRoleSuccess: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Success,
    createPersonnelRoleFailure: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Failure,
    loadingGroup: state.groups.loadState && state.groups.loadState.status == RequestState.Pending,
    user: state.user.data,
    permissions: permissions,
    lookups: state.personnelRole.lookups,
    form: state.reduxForms.personnelRole,
    formState: state.personnelRole.formState,
    formProperties: state.personnelRole.formProperties,
    reduxFormState: state.reduxForms.formState.personnelRole,
    validationFailures: personnelRole ? state.personnelRole.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): IGroupPersonnelEditPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadPersonnelRole: bindActionCreators(PersonnelRoleActions.LoadPersonnelRoleById, dispatch),
    clearPersonnelRole: bindActionCreators(PersonnelRoleActions.Clear, dispatch),
    createPersonnelRole: bindActionCreators(PersonnelRoleActions.CreatePersonnelRole, dispatch),
    savePersonnelRole: bindActionCreators(PersonnelRoleActions.SavePersonnelRole, dispatch),
    loadGroup: bindActionCreators(GroupActions.LoadGroupById, dispatch),
    clearGroup: bindActionCreators(GroupActions.Clear, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GroupPersonnelEditPage);